import { forwardRef } from "react";

import { getCurrencySymbol } from "src/translations";
import { Select, SelectItem, type SelectProps } from "./Select";

type CurrencySelectorProps = Readonly<Omit<SelectProps, "children">>;

// These are currencies the user can select.
// They differ from Currency enum by not allowing PLN which was removed in IBAY-448.
// The values must be a subset of Currency enum values.
enum FrontendCurrency {
    CZK = "CZK",
    EUR = "EUR",
}

export const CurrencySelector = forwardRef<HTMLDivElement, CurrencySelectorProps>((props, ref) => (
    <Select {...props} ref={ref}>
        {Object.keys(FrontendCurrency).map((currency) => (
            <SelectItem key={currency} value={currency}>
                {currency} <span className="text-tertiary">({getCurrencySymbol(currency)})</span>
            </SelectItem>
        ))}
    </Select>
));
